import { useEffect, useState, type FormEvent } from 'react'
import { Link, useParams } from 'react-router-dom'
import { Laden } from '../components/common/States'
import { QualyzApi } from '../services/qualyz'
import { fehlerText } from '../lib/api'

/** Mindestlänge wie im Backend (auth.PASSWORT_MIN). */
const MIN = 8

/**
 * Neues Passwort setzen -- über den Link aus der E-Mail, ohne Anmeldung.
 *
 * Der Link ÖFFNET nur diese Seite; gesetzt wird erst mit dem Knopf. Grund:
 * Mailprogramme und Virenscanner rufen Links im Voraus ab, und ein dabei
 * verbrauchtes Token wäre schwer zu erklären (wie bei den Pro-Anfragen).
 */
export default function PasswortNeuPage() {
  const { token = '' } = useParams()
  const [adresse, setAdresse] = useState<string | null>(null)
  const [laedt, setLaedt] = useState(true)
  const [passwort, setPasswort] = useState('')
  const [wiederholung, setWiederholung] = useState('')
  const [laeuft, setLaeuft] = useState(false)
  const [fehler, setFehler] = useState<string | null>(null)
  const [fertig, setFertig] = useState(false)

  useEffect(() => {
    let vorbei = false
    QualyzApi.passwortNeuPruefen(token)
      .then((d) => !vorbei && setAdresse(d.email))
      .catch((f) => !vorbei && setFehler(fehlerText(f)))
      .finally(() => !vorbei && setLaedt(false))
    return () => {
      vorbei = true
    }
  }, [token])

  const passt = passwort.length >= MIN && passwort === wiederholung

  const absenden = async (e: FormEvent) => {
    e.preventDefault()
    setFehler(null)
    setLaeuft(true)
    try {
      await QualyzApi.passwortNeuSetzen(token, passwort)
      setFertig(true)
    } catch (f) {
      setFehler(fehlerText(f))
    } finally {
      setLaeuft(false)
    }
  }

  return (
    <div className="q-page q-page--schmal">
      <section className="q-card">
        <div className="q-card-head">
          <h3 className="q-card-title">Neues Passwort setzen</h3>
        </div>
        {laedt && <Laden text="Prüfe den Link …" />}
        {!laedt && fertig && (
          <>
            <p className="q-job-result is-ok q-karte-rand">Das Passwort ist gesetzt.</p>
            <p className="q-karte-text">
              Alle vorherigen Anmeldungen sind damit beendet — auch auf anderen Geräten.
            </p>
            <div className="q-job-foot q-karte-rand">
              <span />
              <Link to="/login" className="q-btn q-btn-primary">Jetzt anmelden</Link>
            </div>
          </>
        )}
        {!laedt && !fertig && !adresse && fehler && (
          <>
            <p className="qa-hinweise q-karte-rand">{fehler}</p>
            <div className="q-job-foot q-karte-rand">
              <span className="q-job-meta">Links gelten eine Stunde und nur einmal.</span>
              <Link to="/passwort-vergessen" className="q-btn">Neuen Link anfordern</Link>
            </div>
          </>
        )}
        {!laedt && !fertig && adresse && (
          <form onSubmit={absenden} className="q-formular">
            <p className="q-karte-text">
              Für <strong>{adresse}</strong>. Mindestens {MIN} Zeichen — Länge wirkt mehr
              als Sonderzeichen, deshalb verlangen wir keine.
            </p>
            <label className="q-feld">
              <span>Neues Passwort</span>
              <input
                type="password"
                value={passwort}
                onChange={(e) => setPasswort(e.target.value)}
                autoComplete="new-password"
                required
                autoFocus
              />
            </label>
            <label className="q-feld">
              <span>Noch einmal</span>
              <input
                type="password"
                value={wiederholung}
                onChange={(e) => setWiederholung(e.target.value)}
                autoComplete="new-password"
                required
              />
            </label>
            {passwort && passwort.length < MIN && (
              <p className="q-feld-hinweis">Noch {MIN - passwort.length} Zeichen.</p>
            )}
            {wiederholung && passwort !== wiederholung && (
              <p className="q-feld-hinweis">Die beiden Eingaben sind nicht gleich.</p>
            )}
            {fehler && <p className="qa-hinweise q-karte-rand">{fehler}</p>}
            <div className="q-job-foot">
              <span className="q-job-meta">Dieser Link gilt einmal.</span>
              <button type="submit" className="q-btn q-btn-primary" disabled={laeuft || !passt}>
                {laeuft ? 'Wird gesetzt …' : 'Passwort setzen'}
              </button>
            </div>
          </form>
        )}
      </section>
    </div>
  )
}
